<template>
<Dialog
    :class="[bem([type]), slotContent ? bem('has-left') : '']"
    :visible="visible"
    :showClose="false"
    :maskClosable="maskClosable"
    :keyborad="maskClosable"
    :onCancel="onCancel"
    :afterClose="afterClose"
    :dialogClass="slotContent ? '' :  bem('only-has-auth')"
    @update:visible="v => $emit('update:visible', v)"
    :width="slotContent ? width : authWidth"
>
    <div :class="bem('auth-wrapper')">
        <img v-if="showClose" :class="bem('close')" src="https://cdn.dancf.com/fe-assets/20220407/165ffa5f2f36ce1d72842709d096df78.svg" @click="close">
        <component :is="slotContent" v-if="slotContent" />
        <component :class="bem('choice-enterprise')" :is="slotChoiceEnterprise" @select="onEnterpriseSelect" v-if="slotChoiceEnterprise && isChoiceEnterprise" />
        <template v-else>
            <Auth
                :class="bem('auth-content')"
                :wechatQRCodeCaption="wechatQRCodeCaption"
                @update:type="onUpdateType"
                :type.sync="type"
                :thirdToken="thirdToken"
                :siteType="siteType"
                :deviceName="deviceName"
                :canaryTag="canaryTag"
                @success="handleSuccess"
                @error="handleError"
            >
                <component :is="slotFooter" v-if="slotFooter" slot="footer" />
            </Auth>
        </template>
    </div>
</Dialog>

</template>
<script>
import _Message from "@gaoding/gdui/lib/message";
import _Icon from "@gaoding/gdui/lib/icon";
import _Dialog from "@gaoding/gdui/lib/dialog";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import Auth from './auth.vue';
import { createOAuth2Client } from './oauth2-client';
import { DEFAULT_SITE_TYPE, LOGIN_TYPE } from './constants';
import bemMixin from './bem';
var DEFAULT_WIDTH = '749px';
export default _Dialog.create({
  name: 'g-auth-dialog',
  components: {
    Auth: Auth,
    Icon: _Icon,
    Dialog: _Dialog
  },
  mixins: [bemMixin],
  props: {
    // 显示弹窗 支持 :visible.sync
    visible: {
      type: Boolean,
      default: false
    },
    onOk: {
      type: Function
    },
    onCancel: {
      type: Function
    },
    afterClose: {
      type: Function
    },
    // 是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: true
    },
    // 点击遮罩是否可关闭
    maskClosable: {
      type: Boolean,
      default: false
    },
    // 界面类型
    defaultType: {
      // phone / register / resetpwd / bindphone / qq / wechat
      type: String,
      default: 'wechat'
    },
    thirdToken: {
      type: String,
      default: ''
    },
    wechatQRCodeCaption: String,
    width: {
      // 调用时可以定义 width
      type: String,
      default: DEFAULT_WIDTH
    },
    slotContent: {
      type: Object,
      default: null
    },
    slotFooter: {
      type: Object,
      default: null
    },
    slotChoiceEnterprise: {
      type: Object,
      default: null
    },
    siteType: {
      type: String,
      default: DEFAULT_SITE_TYPE
    },
    deviceName: {
      type: String,
      default: ''
    },
    canaryTag: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var defaultType = this.defaultType;

    if (defaultType === 'login') {
      // 兼容代码
      defaultType = 'wechat';
    }

    return {
      authWidth: '447px',
      type: defaultType,
      isChoiceEnterprise: false
    };
  },
  watch: {
    visible: function visible(v) {
      if (!v) {
        // this.type = this.defaultType;
        this.isChoiceEnterprise = false;
      }
    },
    defaultType: function defaultType() {
      this.type = this.defaultType;
    }
  },
  methods: {
    onUpdateType: function onUpdateType(type) {
      this.$emit('update.type', type, this.type);
    },
    close: function close() {
      this.$emit('update:visible', false);
      if (this.$close) this.$close();
    },
    handleSuccess: function handleSuccess(event) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(event.type !== LOGIN_TYPE.QIYE_WECHAT && _this.slotChoiceEnterprise)) {
                  _context.next = 3;
                  break;
                }

                // 企业登录，切换选择租户
                _this.isChoiceEnterprise = true;
                return _context.abrupt("return");

              case 3:
                if (event.action === 'login') {
                  _Message.success('登录成功');

                  _this.$onOk && _this.$onOk(event);
                }

                _this.$emit('success', event);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleError: function handleError(event) {
      // submit 失败
      // @arg action 操作类型 'login' 'register' 'resetpwd' 等
      // @arg error 失败信息
      this.$emit('error', event);
    },
    onEnterpriseSelect: function onEnterpriseSelect(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var oAuth2Client;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!data || !data.org_id)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                oAuth2Client = createOAuth2Client();
                return _context2.abrupt("return", oAuth2Client.launchreRreshOrgIdFlow({
                  org_id: data.org_id
                }).then(function (res) {
                  if (!res) {
                    var error = new Error("租户绑定失败");

                    _this2.$emit('error', {
                      error: error,
                      action: 'enterpriseSelect',
                      type: 'login'
                    });

                    return;
                  }

                  _this2.isChoiceEnterprise = false;

                  _this2.$emit('success', {
                    data: {},
                    action: 'enterpriseSelect',
                    type: 'login'
                  });
                }).catch(function (error) {
                  _this2.$emit('error', {
                    error: error,
                    action: 'enterpriseSelect',
                    type: 'login'
                  });
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
});
</script>
<style>
/*
 * @Author: 天吾
 * @Date: 2019-01-23 16:29:55
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-11-22 11:24:33
 */
/*
    size 统一用  sm base lg  表示,  对于不能满足的情况, 仿照衣服尺寸加上 x(EXTRA) 比如  font-size-xlg 表示特大
*/
.g-auth-dialog {
  box-sizing: border-box;
}
.g-auth-dialog .g-dialog__header {
  padding: 0;
}
.g-auth-dialog .g-input__inner {
  overflow: hidden;
}
.g-auth-dialog__has-left .g-dialog {
  background: transparent;
}
.g-auth-dialog__has-left .g-dialog__header,
.g-auth-dialog__has-left .g-dialog__footer {
  background: #fff;
}
.g-auth-dialog .g-dialog {
  padding: 0;
  border-radius: 8px;
}
.g-auth-dialog .g-dialog__body {
  margin: 0;
  padding: 0;
}
.g-auth-dialog__close {
  position: absolute;
  top: -36px;
  right: -42px;
  z-index: 10;
  width: 36px;
  height: 36px;
  margin-left: 10px;
  cursor: pointer;
}
.g-auth-dialog__close:hover {
  color: #707070;
}
.g-auth-dialog--bindphone .g-auth-dialog__close {
  display: none;
}
.g-auth-dialog__auth-wrapper {
  display: flex;
  align-items: center;
}
.g-auth-dialog__auth-content {
  overflow: hidden;
  border-radius: 0 8px 8px 0;
}
.g-auth-dialog__choice-enterprise {
  width: 100%;
  height: 480px;
  background: #ffffff;
  border-radius: 0 8px 8px 0;
}
.g-auth-dialog__only-has-auth .g-auth-dialog__auth-content {
  border-radius: 4px;
}

</style>
